<script setup>
import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import BaseBubble from './Base.vue';
import TextBubble from './Text/Index.vue';
import TemplatePreview from 'dashboard/components-next/template-preview/TemplatePreview.vue';
import { useMessageContext } from '../provider.js';

// Mensagem enviada como template da API oficial (campanha, agendamento ou
// envio manual): renderiza o mockup real — header, corpo, rodapé e botões —
// pra atendente ver o que o cliente recebeu, não só o texto do corpo.
const { additionalAttributes, inboxId } = useMessageContext();

const templatesGetter = useMapGetter('inboxes/getFilteredWhatsAppTemplates');

const templateParams = computed(
  () => additionalAttributes.value?.templateParams || null
);

// O template sincronizado da caixa (mesma fonte do picker). Se sumiu de lá
// (apagado/renomeado na Meta), cai no TextBubble normal.
const template = computed(() => {
  const params = templateParams.value;
  if (!params?.name) return null;
  const templates = templatesGetter.value(Number(inboxId.value)) || [];
  return (
    templates.find(
      item =>
        item.name === params.name &&
        (!params.language || item.language === params.language)
    ) || null
  );
});

const variables = computed(() => ({
  ...(templateParams.value?.processedParams?.body || {}),
}));
</script>

<template>
  <BaseBubble
    v-if="template"
    class="!bg-transparent !p-0"
    data-bubble-name="whatsapp-template"
  >
    <TemplatePreview
      :template="template"
      :variables="variables"
      platform="whatsapp"
    />
  </BaseBubble>
  <TextBubble v-else />
</template>
